import { useTranslation } from 'react-i18next';

export default function useLocale() {
    const { i18n } = useTranslation();

    return i18n.language === 'ES' ? 'es-ES' : 'en-US';
}
